<template>
  <el-button type="text" :disabled="false"
             @click="copy">[复制]</el-button>
</template>

<script>
export default {
  name: 'copy-text',
  props: {
    text: { type: String, default: '' }
  },
  methods: {
    copy () {
      this.$copyText(this.text).then(() => {
        this.$message.success('复制成功')
      }, () => {
        this.$message.error('复制失败，请重试')
      })
    }
  }
}
</script>
